import _ from 'lodash';
import { saveAs } from 'file-saver';

import * as consts from './constants';
import * as codiceFiscaleConstants from './utils/codiceFiscale/constants';

class CommonFunctions {

    /**
     * @param {is Date type or a ISO String} birthday 
     * @param {The where to measure the AGE} targetDate 
     */
    static calculateAgeInYear(birthday, targetDate) {
        if (!_.isDate(birthday))
            birthday = new Date(birthday);

        var years = (targetDate.getFullYear() - birthday.getFullYear());

        if (targetDate.getMonth() < birthday.getMonth() || (targetDate.getMonth() === birthday.getMonth() && targetDate.getDate() < birthday.getDate()))
            years--;

        return years;
    }

    static citiesbyCounty(cities, idCounty) {
        if (idCounty) {
            return cities.map(
                (value) => {
                    return { value: value.id, text: value.name, county: value.county };
                }
            ).filter(function (val) {
                return idCounty === val.county;
            }).sort(function (a, b) {
                if (a.text < b.text) return -1;
                if (a.text > b.text) return 1;
                return 0;
            });
        }

        return [];
    }

    static cityById(cities, cityId) {
        if (cityId) {
            var found = cities.filter(function (val) {
                return cityId === val.id;
            });

            if (found.length > 0)
                return found[0];
        }
        return {};
    }

    static sexById(sexId) {
        var found = consts.GENERIC_ENUM.sex.filter(function (val) {
            return sexId === val.value;
        });

        if (found.length > 0)
            return found[0];

        return '';
    }

    static instalmentById(id) {
        var found = consts.GENERIC_ENUM.fractionationType.filter(function (val) {
            return '' + id === val.value;
        });

        if (found.length > 0)
            return found[0];

        return '---';
    }

    static payModeById(id) {
        var found = consts.GENERIC_ENUM.paymentType.filter(function (val) {
            return '' + id === val.value;
        });

        if (found.length > 0)
            return found[0];

        return '---';
    }

    /**
     * @return dd-MM-YYYY
     * @param {Date} date 
     */
    static dateToString(date) {
        try {
            if (date && !_.isDate(date))
                date = new Date(date);
            return _.padStart(date.getDate(), 2, '0') + '-' + _.padStart((date.getMonth() + 1), 2, '0') + '-' + date.getFullYear();
        } catch (err) { }
        return '';
    }

    static isValidDate(value) {
        return value instanceof Date && !isNaN(value.valueOf());
    }

    /**
     * @param {'dd-MM-YYYY'} dateInString 
     * @return Date Object
     */
    static StringToDate(dateInString) {
        try {
            return new Date(_.toNumber(dateInString.substring(6)), _.toNumber(dateInString.substring(3, 5)) - 1, _.toNumber(dateInString.substring(0, 2)));
        } catch (err) { }
        return undefined;
    }

    static formatMoney(value, places, symbol, thousand, decimal) {
        places = !isNaN(places) ? Math.abs(places) : 2;
        symbol = symbol !== undefined ? symbol : '$';
        thousand = thousand || ',';
        decimal = decimal || '.';
        var number = value;
        var negative = number < 0 ? '-' : '';
        var i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
        var j = i.length;
        j = j > 3 ? j % 3 : 0;
        return symbol + ' ' + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
    }

    static numberToItalianEuroFormat(value) {
        return CommonFunctions.formatMoney(_.toNumber(value), 2, '€', '.', ',');
    }

    static numberStringItalianToUsNumber(value) {
        return _.toNumber(value.replace(',', '.')).toFixed(2);
    }

    static reverseString(str) {
        var splitString = str.split('');
        var reverseArray = splitString.reverse();
        return reverseArray.join('');
    }

    static errorMessage(code) {
        var codeIn = _.toInteger(code);
        var error = consts.GENERIC_ENUM.ERROR_MESSAGE.BE.filter(function (val) {
            return codeIn === val.code;
        });
        if (error && error.length > 0)
            return error[0].message;

        return 'Error Generico non definito: ' + codeIn;
    }

    static expirationLastDayOfYear(decorrenza, product) {
        if (_.isNil(decorrenza) || !_.isDate(decorrenza))
            decorrenza = new Date();

        if (product){
          decorrenza = new Date(
            decorrenza.getFullYear(),
            decorrenza.getMonth() + 1,
            product.contractStartingDay,
            12,
            0,
            0
          );

          if (
            product.contractStartingDay != null &&
            product.contractStartingDay === 100
          ) {
            decorrenza = new Date(
              decorrenza.getFullYear(),
              decorrenza.getMonth() + 1,
              1,
              12,
              0,
              0
            );
          }
        }else
        decorrenza = new Date(
          decorrenza.getFullYear(),
          decorrenza.getMonth() + 1,
          1,
          12,
          0,
          0
        );

        var scadenza = new Date(decorrenza.getFullYear(), 11, 31, 12, 0, 0);

        return {
            decorrenza: decorrenza,
            scadenza: scadenza
        };
    }

    static expirationNextYear(decorrenza) {
        if (_.isNil(decorrenza) || !_.isDate(decorrenza)) {
            decorrenza = new Date();
        }

        decorrenza.setHours(12, 0, 0, 0);
        var scadenza = new Date(decorrenza);
        scadenza.setFullYear(decorrenza.getFullYear() + 1);

        return {
            decorrenza: decorrenza,
            scadenza: scadenza
        };
    }

    static expirationContractDates(product, decorrenza) {
        if (product.contractPeriodMode === consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.EXPIRATION_LAST_DAY_OF_YEAR ||
            product.contractPeriodMode === consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.COLLETTIVA_LAST_DAY_OF_YEAR ||
            product.contractPeriodMode === consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.FORFAIT_LAST_DAY_OF_YEAR) {
            return CommonFunctions.expirationLastDayOfYear(decorrenza, product);
        }
        else if (product.contractPeriodMode === consts.GENERIC_ENUM.CONTRACT_PERIOD_MODE.COVID_19) {
            return CommonFunctions.expirationLastDayOfYear(decorrenza, product);
        }
        else {

             if (_.isNil(decorrenza) || !_.isDate(decorrenza)) {
               decorrenza = new Date();
             }
             if (
               product.contractStartingDay != null &&
               product.contractStartingDay === 100
             ) {
               decorrenza = new Date(
                 decorrenza.getFullYear(),
                 decorrenza.getMonth() + 1,
                 1,
                 12,
                 0,
                 0
               );
             }
            return CommonFunctions.expirationNextYear(decorrenza);
        }

    }

    static dateDiffInDays(startDate, endDate) {
        var oneDay = 1000 * 60 * 60 * 24;
        return Math.ceil((endDate.getTime() - startDate.getTime()) / (oneDay));
    }

    static allContractsStatus() {
        return [{ value: consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA, text: 'Adesione' },
        { value: consts.GENERIC_ENUM.CONTRACT_STATUS.ANNULLO, text: 'Annullo' },
        { value: consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO, text: 'Preventivo' },
        { value: consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO_COFERMATO, text: 'Preventivo Confermato' },
        { value: consts.GENERIC_ENUM.CONTRACT_STATUS.CHIUSA, text: 'Adesione Chiusa' }];
    }

    static allRoles() {
        return [{ value: consts.AUTHENTICATION.USER_ROLE.Admin, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.Admin) },
        { value: consts.AUTHENTICATION.USER_ROLE.CentraleOperativa, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.CentraleOperativa) },
        { value: consts.AUTHENTICATION.USER_ROLE.Fab, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.Fab) },
        { value: consts.AUTHENTICATION.USER_ROLE.NetworkMaster, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.NetworkMaster) },
        { value: consts.AUTHENTICATION.USER_ROLE.NetworkAgent, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.NetworkAgent) },
        { value: consts.AUTHENTICATION.USER_ROLE.NetworkReferent, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.NetworkReferent) },
        { value: consts.AUTHENTICATION.USER_ROLE.Seb, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.Seb) },
        { value: consts.AUTHENTICATION.USER_ROLE.NetworkOwner, text: CommonFunctions.roleInString(consts.AUTHENTICATION.USER_ROLE.NetworkOwner) }];
    }

    static ageLimtsForCombo() {
        return [{ value: consts.AGE_LIMITS.TYPES.NO_LIMITS, text: 'Nessun Limite.' },
        { value: consts.AGE_LIMITS.TYPES.NO_65_AND_OVER_65, text: 'Solo sotto i 65 anni.' },
        { value: consts.AGE_LIMITS.TYPES.NO_UNDER_65, text: 'Solo sopra i 65 anni compresi.' },
        { value: consts.AGE_LIMITS.TYPES.JUST_ONE_OVER_65, text: 'Solo una persona sopra i 65 anni compresi.' },
        { value: consts.AGE_LIMITS.TYPES.NO_35_AND_OVER_35, text: 'Solo sotto i 35 anni non compresi.' },
        { value: consts.AGE_LIMITS.TYPES.NO_UNDER_35_NO_65_AND_OVER_65, text: 'Solo sopra i 35 anni compresi e sotto i 65 anni non compresi.' }];
    }

    static createNetwork() {
        return {
            id: -1,
            businessName: '',
            code: '',
            dataFineAttivita: null,
            dataInizioAttivita: null,
            documents: [],
            extraNoteEnabled: false,
            heading: '',
            iban: '',
            ibanNote: '',
            iban2: '',
            iban2Note: '',
            idCounty: '',
            idCity: -1,
            networkTariff: { warranties: [] },
            nofEmployees: 0,
            noteAggiuntive: '',
            onContractNotification: { owner: false, agent: false, client: false },
            password: '',
            referents: [],
            site: '',
            street: '',
            userData: {
                ateco: '',
                emailAddress: '',
                emailAddress2: '',
                firstName: '',
                lastName: '',
                password: '',
                sae: '',
                taxCode: '',
                username: '',
                workPhone: '',
                workPhone2: ''
            },
            vatCode: ''
        };
    }

    static createContract() {
        // By default we set this dates ì. They will be changed based on the product type
        var dates = CommonFunctions.expirationLastDayOfYear();
        return {
            customrSearch: {
                taxCode: '',
                surname: '',
                vatCode: '',
                businessName: '',
                result: [],
                selectedCustomerId: -1
            },
            status: consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE,
            datiContrattoContraente: {
                email: '',
                mobile: '',
                phone: ''
            },
            datiPagamento: {
                startDate: dates.decorrenza,
                endDate: dates.scadenza
            },
            documents: [],
            members: [],
            accountperiods: [],
            personType: -1,
            payMode: -1,
            instalmentMode: -1,
            personaFisica: {
                id: -1,
                name: '',
                surname: '',
                birthDate: null,
                bornCounty: '',
                bornCity: -1,
                sex: 1,
                taxCode: '',
                county: '',
                city: -1,
                street: '',
                familyMembers: []
            },
            personaGiuridica: {
                id: -1,
                businessName: '',
                county: '',
                fileBenificiari: { name: '' },
                numeroDipendenti: 0,
                street: '',
                vatCode: '',
                legaleRappresentante: {
                    familyTree: consts.GENERIC_ENUM.FAMILY_TREE_TYPES.LEGALE_RAPPRESENTANTE,
                    name: '',
                    surname: '',
                    birthDate: null,
                    bornCounty: '',
                    bornCity: -1,
                    sex: 1,
                    taxCode: '',
                    county: '',
                    city: -1,
                    street: '',
                }
            },
            pianoFlex: CommonFunctions.pianoFlexCreate(),
            productId: -1
        };
    }

    static pianoFlexCreateFamiliareEmpty(contract) {
        return {
            idParentMember: -1,
            iban: '', // Used
            pianoFlex: CommonFunctions.pianoFlexCreate(contract)
        };
    }

    static pianoFlexCreateDeleteFamiliare(contract) {
        return {
            endDate: null,
            iban: '',
            pianoFlex: CommonFunctions.pianoFlexCreate(contract)
        };
    }

    static pianoFlexCreate(contract) {
        return {
            name: '',
            note: '',
            pgFactoryFee: 0,
            pgEmployeeFee: 0,
            pgRelativeFee: 0,
            pfSubscriberFee: 0,
            pfRelative: 0,
            pianoFlexWarranty: CommonFunctions.pianoFlexCreateBasewarranties(contract),
            netAmount: 0,
            quotaIscrizione: 0,
            grossAmount: 0
        };
    }

    static pianoFlexCreateBasewarranties(contract) {
        if (!_.isNil(contract) && contract.isPianoFlex && contract.pianoFlex.pianoFlexWarranty && contract.pianoFlex.pianoFlexWarranty.length > 0) {
            const appArray = _.cloneDeep(contract.pianoFlex.pianoFlexWarranty.filter(x => {
                return contract.pianoFlex.pianoFlexWarranty[0].periodIdentifier === x.periodIdentifier;
            }));
            let index = 0;
            appArray.forEach(element => {
                element.id = index--;
                element.amount = 0;
            });

            return appArray;
        }
        return [{
            amount: 0,
            id: 0,
            idInsuranceCompany: consts.GENERIC_ENUM.PIANO_FLEX.COMPANY_FIRST_WARRANTY,
            name: 'Prestazioni Sanitarie Integrative',
            printedNote: ''
        }];
    }

    static getValuesForQuotaIscrizioneAndQuota(contract, commonstate, product) {
        const role = _.toNumber(contract.personType) === consts.GENERIC_ENUM.personType[1].value ? 'Pg' : 'Pf';
        const subscriptions = commonstate.configuration.subscriptions.filter(x => x.role === role);
        let totalAmount = 0;

        // If Persona Fisica
        if (role === 'Pf') {
            let appV = 0;
            if (product && product.forzaQuote) {
                appV = product.pfSubscriberFee + (product.pfRelative * contract.personaFisica.familyMembers.length);
            } else if (!_.isNil(subscriptions.filter(x => x.type === 'Subscriber')[0])) {
                appV = subscriptions.filter(x => x.type === 'Subscriber')[0].cost +
                    (subscriptions.filter(x => x.type === 'Relative')[0].cost * contract.personaFisica.familyMembers.length);
            }
            totalAmount = appV;
        } else {
            // TODO: if PG we have a problem cos in a contract you do not have number of people
        }

        const compObject = {
            subscriptions: subscriptions,
            totalAmount: totalAmount
        };

        return compObject;
    }

    static getValuesForQuotaIscrizioneAndQuotaPianoFlex(contract, commonstate) {
        const role = _.toNumber(contract.personType) === consts.GENERIC_ENUM.personType[1].value ? 'Pg' : 'Pf';
        let totalAmount = 0;
        let quotaIscrizione = 0;

        // If Persona Fisica
        if (role === 'Pf') {
            quotaIscrizione = contract.pianoFlex.pfSubscriberFee + contract.pianoFlex.pfRelative * contract.personaFisica.familyMembers.length;
            totalAmount += quotaIscrizione;
        } else {
            // TODO: if PG we have a problem cos in a contract you do not have number of people
        }

        const compObject = {
            quotaIscrizione: quotaIscrizione,
            totalAmount: totalAmount
        };

        return compObject;
    }

    static codiceFiscaleErrorInString(code, cf) {
        if (codiceFiscaleConstants.ERROR_CODES.SYNTAX_ERROR === code)
            return 'Errore di Sintassi nel codice Fiscale: ' + cf;
        if (codiceFiscaleConstants.ERROR_CODES.NAME_ERROR === code)
            return 'Nome non corretto nel codice Fiscale: ' + cf;
        if (codiceFiscaleConstants.ERROR_CODES.SURNAME_ERROR === code)
            return 'Cognome non corretto nel codice Fiscale: ' + cf;
        if (codiceFiscaleConstants.ERROR_CODES.BDAY_ERROR === code)
            return 'Data non corretta nel codice Fiscale: ' + cf;

        return '---';
    }

    static contractStatusInString(statusId) {
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.ANNULLO === statusId)
            return 'Annullo Tecnico';
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.CHIUSA === statusId)
            return 'Adesione Cessata';
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.CREAZIONE === statusId)
            return 'In Creazione';
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO === statusId)
            return 'Inserito';
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.PREVENTIVO_COFERMATO === statusId)
            return 'Confermato';
        if (consts.GENERIC_ENUM.CONTRACT_STATUS.POLIZZA === statusId)
            return 'Adesione';

        return '---';
    }

    static accountPeriodActivityInString(accountPeriodActivityIn) {
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.AGGIUNTA_FAMILIARE === accountPeriodActivityIn)
            return 'Aggiunta familiare';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.EMISSIONE === accountPeriodActivityIn)
            return 'Emissione';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.QUIETANZIAMENTO === accountPeriodActivityIn)
            return 'Quietanziamento';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.RIMBORSO === accountPeriodActivityIn)
            return 'Rimborso';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_ACTIVITY.RINNOVO === accountPeriodActivityIn)
            return 'Rinnovo';

        return '---';
    }

    static roleInString(roleId) {
        if (consts.AUTHENTICATION.USER_ROLE.Admin === roleId)
            return 'Amministratore';
        if (consts.AUTHENTICATION.USER_ROLE.CentraleOperativa === roleId)
            return 'Centrale Operativa';
        if (consts.AUTHENTICATION.USER_ROLE.Fab === roleId)
            return 'Fab';
        if (consts.AUTHENTICATION.USER_ROLE.NetworkMaster === roleId)
            return 'Master';
        if (consts.AUTHENTICATION.USER_ROLE.NetworkAgent === roleId)
            return 'Operatore';
        if (consts.AUTHENTICATION.USER_ROLE.NetworkReferent === roleId)
            return 'Referente';
        if (consts.AUTHENTICATION.USER_ROLE.NetworkOwner === roleId)
            return 'Socio Sostenitore';
        if (consts.AUTHENTICATION.USER_ROLE.Seb === roleId)
            return 'Grifo';

        return '---';
    }

    static familyTreeInString(familyTree) {
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.CONVIVENTE_MORE_UXORIO === familyTree)
            return 'Convivente More Uxorio';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.CAPO_NUCLEO === familyTree)
            return 'Caponucleo';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.FIGLIA === familyTree)
            return 'Figlia';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.FIGLIO === familyTree)
            return 'Figlio';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.MADRE === familyTree)
            return 'Madre';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.MARITO === familyTree)
            return 'Marito';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.MOGLIE === familyTree)
            return 'Moglie';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.PADRE === familyTree)
            return 'Padre';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.FRATELLO === familyTree)
            return 'Fratello';
        if (consts.GENERIC_ENUM.FAMILY_TREE_TYPES.SORELLA === familyTree)
            return 'Sorella';

        return '---';
    }

    static businessRoleInString(businessRole) {
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.AMMINISTRATORE === businessRole)
            return 'Amministratore';
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.DIRIGENTE === businessRole)
            return 'Dirigente';
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.IMPIEGATO === businessRole)
            return 'Impiegato';
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.OPERAIO === businessRole)
            return 'Operaio';
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.QUADRO === businessRole)
            return 'Quadro';
        if (consts.GENERIC_ENUM.BUSINESS_ROLE_TYPES.FAMILIARE_NON_A_CARICO === businessRole)
            return 'Familiare non a Carico';

        return '---';
    }

    static accountPeriodStatusInString(code) {
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.ANNULLATO === code)
            return 'ANNULLATO';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.ESITO_PAGAMENTO_KO === code)
            return 'NON PAGATO';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.ESITO_PAGAMENTO_OK === code)
            return 'PAGATO';
        if (consts.GENERIC_ENUM.ACCOUNT_PERIOD_STATUS.PAGAMENTO === code)
            return 'IN ATTESA DI PAGAMENTO';

        return '---';
    }

    static frazionamentoInString(instalment) {
        if (consts.GENERIC_ENUM.FRAZIONAMENTO_TYPES.ANNUO === instalment)
            return 'Annuo';
        if (consts.GENERIC_ENUM.FRAZIONAMENTO_TYPES.MENSILE === instalment)
            return 'Mensile';
        if (consts.GENERIC_ENUM.FRAZIONAMENTO_TYPES.SEMSTRALE === instalment)
            return 'Semestrale';
        if (consts.GENERIC_ENUM.FRAZIONAMENTO_TYPES.TRIMESTRALE === instalment)
            return 'Trimestrale';

        return '---';
    }

    /**
     * This function can convert a text file to blob and save it, but not another type of file.
     * 
     * @param {*} file 
     * @param {*} fileName 
     */
    static saveInCSV(file, fileName) {
        if (_.isUndefined(fileName))
            fileName = 'export.csv';

        var byteNumbers = new Array(file.length);
        for (var i = 0; i < file.length; i++)
            byteNumbers[i] = file.charCodeAt(i);

        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: 'application/csv' });
        saveAs(blob, fileName);
    }

    static saveExcel(base64Value, fileName) {
        CommonFunctions.saveFile(base64Value, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }

    /**
     * This function can receive a base64 string in input and save it as a file.
     * 
     * The C# controller should be like this  return Convert.ToBase64String(byte[]....);
     * 
     * @param {*} base64Value: 'base64Value' in XMLHttpRequest this.response
     * @param {*} fileName: 'export.xlsx'
     * @param {*} fileType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
     */
    static saveFile(base64Value, fileName, fileType) {
        var byteCharacters = atob(base64Value);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], { type: fileType });
        saveAs(blob, fileName);
    }

    static dynamicLogoUrlComposer(authenticationState, networkId) {
        return process.env.REACT_APP_LOGO_URL + encodeURIComponent(networkId) + '&token=' + encodeURIComponent(authenticationState.token);
    }

    static dynamicLogoUrlComposerNoCache(authenticationState, networkId) {
        return CommonFunctions.dynamicLogoUrlComposer(authenticationState, networkId) + '&t=' + new Date().getTime();
    }
}

export default CommonFunctions;
